import * as TAB_VARIATIONS from './tab-variation';

export { TabHeader } from './tab-header';
export { TabBar } from './tab-bar';
export { TAB_VARIATIONS };
